// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.emp-sessions {
  width: 300px;
  height: 350px;
  text-align: center;
  background: white;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: flex-start;
  overflow: hidden;
}

.emp-sessions h3 {
  margin-top: -15%;
}

.emp-sessions p {
  margin-top: -18%;
  color: #686868;
  font-size: small;
}

.chart-container {
  width: 100%;
  height: 180px;
  position: relative;
}

.chart-center-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
.chart-center-label p
{
  margin-top: 10%;
  color: #333;
}`, "",{"version":3,"sources":["webpack://./src/components/MyEmpDashboard/EmpSessions.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;AACA;;EAEE,eAAe;EACf,WAAW;AACb","sourcesContent":[".emp-sessions {\n  width: 300px;\n  height: 350px;\n  text-align: center;\n  background: white;\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: flex-start;\n  overflow: hidden;\n}\n\n.emp-sessions h3 {\n  margin-top: -15%;\n}\n\n.emp-sessions p {\n  margin-top: -18%;\n  color: #686868;\n  font-size: small;\n}\n\n.chart-container {\n  width: 100%;\n  height: 180px;\n  position: relative;\n}\n\n.chart-center-label {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 16px;\n  font-weight: bold;\n  color: #333;\n}\n.chart-center-label p\n{\n  margin-top: 10%;\n  color: #333;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
